import { useCallback, useRef, useState } from "react";
import { AxiosRequest } from "_services/api";
import type { IProcessoTaxa } from "../ModalSelecionarProcessos";

export interface IFiltroProcessosElegiveis {
  idEmpresa?: number | null;
  idsProcessos?: string[];
  dadosVeiculos?: string[];
  idsExcluir?: number[];
}

export function useProcessosElegiveis() {
  const msAw = AxiosRequest.makeApi(process.env.REACT_APP_MS_AW);

  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState<IProcessoTaxa[]>([]);
  const [totalRows, setTotalRows] = useState(0);
  const requestIdRef = useRef(0);

  const buscar = useCallback(
    async (filtros: IFiltroProcessosElegiveis = {}, pagina = 1, limite = 50) => {
      const requestId = requestIdRef.current + 1;
      requestIdRef.current = requestId;
      setLoading(true);

      const params = new URLSearchParams();
      params.append("pagina", String(pagina));
      params.append("limite", String(limite));

      if (filtros.idEmpresa) params.append("idEmpresa", String(filtros.idEmpresa));
      if (filtros.idsProcessos?.length) {
        params.append("processos", JSON.stringify(filtros.idsProcessos));
      }
      if (filtros.dadosVeiculos?.length) {
        params.append("veiculos", JSON.stringify(filtros.dadosVeiculos));
      }
      if (filtros.idsExcluir?.length) {
        params.append("excluir", JSON.stringify(filtros.idsExcluir));
      }

      try {
        const { data } = await msAw.get(
          `/financeiro/pagamento-taxa/lote/processos-elegiveis?${params}`,
        );
        if (requestId !== requestIdRef.current) return;
        setDados(data?.itens ?? []);
        setTotalRows(data?.meta?.total ?? 0);
      } catch {
        if (requestId !== requestIdRef.current) return;
        // 404 = "Nenhum processo encontrado" (padrão do ms) -> lista vazia.
        setDados([]);
        setTotalRows(0);
      } finally {
        if (requestId !== requestIdRef.current) return;
        setLoading(false);
      }
    },
    [],
  );

  const limpar = useCallback(() => {
    requestIdRef.current += 1;
    setLoading(false);
    setDados([]);
    setTotalRows(0);
  }, []);

  return { loading, dados, totalRows, buscar, limpar };
}
